const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Search24 = function Search24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "m21.71 20.29-3.68-3.68a9.015 9.015 0 1 0-1.42 1.42l3.68 3.68c.19.186.445.29.71.29a1 1 0 0 0 1-1c0-.265-.104-.52-.29-.71zM11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14z",
      fill: "currentColor",
    })
  );
};
Search24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Search16 = function Search16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7A5 5 0 1 1 2 7a5 5 0 0 1 10 0zm-.81 5.608a7 7 0 1 1 1.418-1.418l3.102 3.103c.186.189.29.443.29.709a.999.999 0 0 1-.998.998c-.266 0-.52-.104-.71-.29l-3.102-3.102zM14 5.238v-.472c.004.157.004.315 0 .472z",
      fill: "currentColor",
    })
  );
};
Search16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Search24,
  16: Search16,
};
export function Search(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Search' icon. Please use one of the available sizes: '16', '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
